/* eslint-disable no-undef */
import React, { useState, Suspense, lazy } from 'react'; // Importamos React
import Share from '../icons/Share';
import './socialStyles.css';

const CustomModal = lazy(() => import('../modal/CustomModal'));
const SocialModal = lazy(() => import('./SocialModal'));

export default function ShareButton() {
  const [showModal, setShowModal] = useState(false);
  const switchModal = () => setShowModal((show) => !show);
  return (
    <>
      <div id="myshare" onClick={switchModal} className="tpx-social-media">
        <Share />
      </div>
      <Suspense>
        <CustomModal show={showModal} onClose={switchModal}>
          <SocialModal />
        </CustomModal>
      </Suspense>
    </>
  );
}
